<template>
  <div :class="formGroupClass" style="margin-bottom: 0">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-date-of" class="control-label">{{ inputLabel }}</label>
    <div class="input-group">
      <date-picker
        v-model="inputValue"
        :disabled="disabled"
        :value-type="dateValueType"
        :format="dateFormat"
        :disabled-date="isDisabledDate"
        id="form-pass-date-of"
        @input="emitValue('input', $event)"
        @change="emitValue('change', $event)"
        @blur="emitValue('change', $event)"
      />
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import datePickerConfigMixin from '../../../../mixins/application-form/datePickerConfigMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'ContractEndDateInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin,
    datePickerConfigMixin
  ],

  props: {
    inputLabel: {
      default: 'Дата окончания договора'
    },

    inputName: {
      default: 'contract_end_date'
    },

    inputHint: {
      default: undefined
    }
  }
}
</script>
